import { BLACKOUT_DAYS_TYPES } from '../../../../../lib/service/ProgramService';
import { createError } from '../../../../../lib/error';
import {
  boundFromValidDates,
  formatMinutesDuration,
  PROGRAM_DATE_FORMATS,
  RECAP_TIMESTAMP_FORMATS,
} from '../../../../../lib/dateutil';
class EditPositionModalController {
  constructor(
    $scope,
    $rootScope,
    $uibModalInstance,
    $q,
    DEBUG,
    GeoService,
    DateTimeService,
    VenueService,
    StaffUserService,
    geolocation,
    translateFilter,
    moment,
    position,
    staffUser,
    APIService,
    TaskQueueService,
    DataSyncService,
    LogService,
    PositionService,
  ) {
    "ngInject";
    this.$scope = $scope;
    this.$rootScope = $rootScope
    this.$uibModalInstance = $uibModalInstance;
    this.$q = $q;
    this.DEBUG = DEBUG;
    this.GeoService = GeoService;
    this.DateTimeService = DateTimeService;
    this.VenueService = VenueService;
    this.StaffUserService = StaffUserService;
    this.geolocation = geolocation;
    this.translateFilter = translateFilter;
    this.moment = moment;
    this.position = position;
    this.program = false;
    this.staffUser = staffUser;
    this.APIService = APIService;
    this.TaskQueueService = TaskQueueService;
    this.DataSyncService = DataSyncService;
    this.LogService = LogService;
    this.PositionService = PositionService;
    this.editForm = {};
    this.selectedSearchVenue = {};

    this._errors = [];
    this.errors = [];
    this.minMaxTimeError = false;
    this.scheduleRuleError = null;
    this.scheduleWarningMessage = null;
    this._location = null;
    this._GPSStatusMessage = false;
    this._placesLoading = false;
    this._showLocationSelector = false;

    // Used as a marker to prevent reloading from Places result when selecting the tab if result exists.
    this._coordinatesOfPlaceSearchResult = false;

    this.lat = false;
    this.lng = false;

    this._eventDatePickerOptions = {
      minDate: null,
      maxDate: null,
    };

    this._savingPosition = false;
  }

  $onInit() {
    this.GPSStatusMessage = "GETTING_GPS_LOCATION";

    this.geolocation.getLocation().then((data) => {
      this.lat = data.coords.latitude;
      this.lng = data.coords.longitude;
      this.GeoService.latLngLookup(this.lat + ',' + this.lng)
        .then((response) => {
          this.GPSStatusMessage = false;
          this._location = response.data.results[0].formatted_address;
        });
    })
      .catch(() => {
        this.GPSStatusMessage = "GPS_LOCATION_FAILED";
      });

    // Hide the location selector and restore the venue details if the selector is cancelled
    this.$scope.$on('cancelLocationSelect', () => {
      this.locationSelectorVisible = false;

      // Reset this to default value
      this.populateSelectedSearchVenueWithEventDefault();
    });

    const program = this.staffUser.programs.find((el) => {
      return parseInt(el.id) === parseInt(this.position.programs_id);
    });
    this.program = program;

    // All event types for the program are available, not just child types like for Guerrilla
    const availableEventTypes = program.event_types;
    this.editForm.event_type = availableEventTypes.find((el) => {
      return parseInt(el.id) === parseInt(this.position.event.events_types_id);
    })

    this.availableEventTypes = availableEventTypes;
    // If only one event type is available then this is the one that must be used.
    if (availableEventTypes.length === 1) {
      this.editForm.event_type = availableEventTypes[0];
    }

    this.editForm.name = this.position.event.name;
    this.editForm.description = this.position.event.additional_event_notes;

    this.editForm.recapDefinition = this.position.event.recapDefinition;

    /**
     * NOTE: We no longer do any time zone conversion here. Datetimes from the API that don't include timezone are read
     * as local browser time. Datetimes that are sent to the API are stripped of timezones identifiers, so essentially,
     * all datetimes in the app can be treated as if they're in the server time, even though the objects are marked as
     * local browser time.
     */

    let startTime = this.position.event.start_timestamp;
    let endTime = this.position.event.end_timestamp;

    /*
     * Note 2: That didn't work right. See bug MJOL-519.
     * Trying to do conversion again.
     */
    const eventTimezone = this.position && this.position.event && this.position.event.timezoneName;
    if (eventTimezone) {
      if (startTime) {
        startTime = this.DateTimeService.shiftDateObjectFromLocal(startTime, eventTimezone);
      }
      if (endTime) {
        endTime = this.DateTimeService.shiftDateObjectFromLocal(endTime, eventTimezone);
      }
    }

    this.editForm.start_time = startTime;
    this.editForm.date = startTime;
    this.editForm.end_time = endTime;

    this.refreshEventScheduleMessages();
    this.refreshTimeMessages();

    this.populateSelectedSearchVenueWithEventDefault();
  }

  /**
   * Rebuilds the error list from every rule failing right now, and reports
   * whether the form may be saved. Every failing rule is listed together: a date
   * and a duration problem are independent, and fixing one only to be shown the
   * other reads as a new failure. Duration is skipped while a time is unset,
   * since it would then report a meaningless violation on top of the
   * missing-time error.
   *
   * @returns boolean
   */
  collectValidationErrors() {
    this._clearErrors();

    const validTimes = this.verifyEventTimeValidity();
    if (!validTimes) {
      this._addError(createError({
        error: 'EventTimeError',
        message: 'Start Time and End Time hour values must be 1 or greater (12 hour time format).',
        key: 'ERROR_EVENT_START_END_TIMES_NOT_VALID',
      }));
    }

    if (validTimes && !this.verifyProgramMeetsMinMaxTimes()) {
      this._addError(createError({
        error: 'EventDurationError',
        message: this.minMaxTimeError,
        key: 'ERROR_EVENT_DURATION_OUTSIDE_MIN_MAX',
      }));
    }

    if (!this.verifyEventBlackoutDayValidity()) {
      this._addError(createError({
        error: 'EventDateError',
        message: 'Event must not be scheduled on blackout date.',
        key: 'ERROR_EVENT_DATE_ON_BLACKOUT_DATE',
      }));
    }

    if (!this.refreshEventScheduleMessages()) {
      this._addError(createError({
        error: 'EventDateError',
        message: this.scheduleRuleError,
        key: 'ERROR_EVENT_DATE_INSIDE_SCHEDULE_RULE',
      }));
    }

    return !this.errors.length;
  }

  /**
   * Re-runs the whole rule set after an edit, rather than clearing the list:
   * a blackout date has no inline message of its own, so dropping it on an
   * unrelated change would hide a violation that is still true. Silent until a
   * save has been attempted, so a form being filled in is not pre-emptively
   * marked up.
   */
  revalidateAfterChange() {
    if (!this.errors.length) {
      return;
    }

    this.collectValidationErrors();
  }

  /**
   * Every change handler revalidates last. verifyEventDateValidity() nulls a
   * date outside the window, so a list rebuilt before it describes a form state
   * that no longer exists.
   */
  onDateChanged() {
    this.verifyEventDateValidity();
    this.refreshEventScheduleMessages();
    // The duration is independent of the date, but its inline message still has
    // to keep up while no save has been attempted.
    this.refreshTimeMessages();
    this.revalidateAfterChange();
  }

  /**
   * Keeps the duration message current without reporting an unset time, which
   * the user has not necessarily reached yet.
   */
  refreshTimeMessages() {
    if (!this.editForm.start_time || !this.editForm.end_time) {
      this.minMaxTimeError = false;
      return;
    }

    this.verifyProgramMeetsMinMaxTimes();
  }

  /**
   * Event Schedule Rule blocks the save with the configured message; the warning
   * only displays. Both are resolved server-side onto the program.
   *
   * @returns boolean whether the date satisfies the rule
   */
  refreshEventScheduleMessages() {
    if (!this.program) {
      this.scheduleRuleError = null;
      this.scheduleWarningMessage = null;

      return true;
    }

    this.scheduleRuleError = this.program.eventScheduleRuleViolation(this.editForm.date);
    // The rule already blocks this date, so its advisory warning is just noise.
    this.scheduleWarningMessage = this.scheduleRuleError
      ? null
      : this.program.eventScheduleWarning(this.editForm.date);

    return !this.scheduleRuleError;
  }

  /**
   * The event's recap definition, from whichever source has it: the picker and
   * the date clamp each used to read a different one, so a missing
   * position.event.recapDefinition cleared a date the picker still bounded.
   */
  _recapDefinition() {
    if (this.editForm && this.editForm.recapDefinition) {
      return this.editForm.recapDefinition;
    }

    const eventsRecapsId = this.position?.event?.events_recaps_id;

    return this.program && this.program.recap_definitions && eventsRecapsId
      ? this.program.recap_definitions.find((el) => parseInt(el.id) === parseInt(eventsRecapsId))
      : null;
  }

  /**
   * The program/recap window a date has to fall inside. One builder for the
   * picker bounds and for the clamp below, so a typed date is held to the same
   * window the picker offers.
   *
   * The Event Schedule Rule is only part of the picker's window. It is reported
   * with the client's configured message by refreshEventScheduleMessages() and
   * blocks the save, so clamping on it as well would silently discard the date
   * and take the explanation with it.
   *
   * @param {boolean} includeScheduleRule grey out the days the rule disallows
   *
   * @returns {?{minDate: ?Date, maxDate: ?Date}} null when no window applies
   */
  _eventDateWindow({ includeScheduleRule = false } = {}) {
    const recapDefinition = this._recapDefinition();
    if (!this.editForm || !this.program || !recapDefinition) {
      return null;
    }

    const scheduleRuleDate = includeScheduleRule ? this.program.earliestScheduleRuleDate() : null;
    // An absent date is no bound at all. It has to be kept away from moment()
    // rather than left to isValid(), because moment(undefined) is *now* — that
    // would bound the window at today and clamp away every earlier date.
    const parsed = (value, formats) => (value ? this.moment(value, formats) : null);

    // the date formats we're getting back from the program and the recap definition are different
    // and Safari (and ios) doesn't like YYYY-mm-dd ISO format, which is nuts, but it is what it is
    return {
      minDate: boundFromValidDates(this.moment.max, [
        parsed(this.program.start_date, PROGRAM_DATE_FORMATS),
        parsed(recapDefinition.recap_available_events_start_time, RECAP_TIMESTAMP_FORMATS),
        parsed(scheduleRuleDate),
      ]),
      maxDate: boundFromValidDates(this.moment.min, [
        parsed(this.program.end_date, PROGRAM_DATE_FORMATS),
        parsed(recapDefinition.recap_available_events_end_time, RECAP_TIMESTAMP_FORMATS),
      ]),
    };
  }

  verifyEventDateValidity() {
    if (!this.editForm.date) {
      return;
    }

    const dateWindow = this._eventDateWindow();
    if (!dateWindow) {
      this.editForm.date = null;
      return;
    }

    // An end with nothing parseable behind it is unbounded, not violated.
    const eventDate = new Date(this.editForm.date);
    const beforeWindow = dateWindow.minDate && eventDate < dateWindow.minDate;
    const afterWindow = dateWindow.maxDate && eventDate > dateWindow.maxDate;

    if (beforeWindow || afterWindow) {
      this.editForm.date = null;
    }
  }

  verifyEventBlackoutDayValidity() {
    if (!this.editForm.date) {
      return true;
    }
    let eventDate = new Date(this.editForm.date);
    if (this.program.blackout_type === BLACKOUT_DAYS_TYPES.PROGRAM) {
      const daysOfWeek = this.program.blackout_days.map(Number);
      return !daysOfWeek.includes(eventDate.getDay());
    }
    if (this.program.blackout_type === BLACKOUT_DAYS_TYPES.PROGRAM_CHAIN) {
      const chainsId = this.selectedSearchVenue?.parent_chains_id;
      if (chainsId) {
        const daysOfWeek = this.program.blackout_days[chainsId]?.map(Number);
        // No blackout days configured for this chain, so nothing to violate.
        if (!daysOfWeek) return true;
        return !daysOfWeek.includes(eventDate.getDay());
      }
    }

    return true
  }

  verifyEventTimeValidity() {
    if (this.editForm.start_time == null) {
      this.minMaxTimeError = "Start Time hour must be set to 1 or greater (12 hour time format).";
      return false;
    }

    if (this.editForm.end_time == null) {
      this.minMaxTimeError = "End Time hour must be set to 1 or greater (12 hour time format).";
      return false;
    }

    this.minMaxTimeError = null;
    return true;
  }

  verifyProgramMeetsMinMaxTimes() {
    if (!this.program) {
      return true;
    }

    if (!this.editForm.start_time || !this.editForm.end_time) {
      return true; // verifyEventTimeValidity() reports the unset time
    }

    const limits = this.program.eventDurationLimits(this.editForm.event_type);

    const start = new Date(this.editForm.start_time);
    const end = new Date(this.editForm.end_time);
    // If the start time is after the end time, add 24 hours
    if (start > end) {
      end.setDate(end.getDate() + 1);
    }
    const diffMinutes = (end - start) / 1000 / 60;

    // Equal times read as 0 rather than 24 hours, and a zero-length shift is
    // never valid, even where no level sets a minimum.
    if (diffMinutes === 0) {
      this.minMaxTimeError = 'End time must be after start time';
      return false;
    }

    if (limits.min === 0 && limits.max === 0) {
      this.minMaxTimeError = false;
      return true;
    }

    if (limits.min !== 0 && diffMinutes < limits.min) {
      this.minMaxTimeError = `Shift must be at least ${formatMinutesDuration(limits.min)}`;
      return false;
    }
    if (limits.max !== 0 && diffMinutes > limits.max) {
      this.minMaxTimeError = `Shift cannot exceed ${formatMinutesDuration(limits.max)}`;
      return false;
    }
    this.minMaxTimeError = false;
    return true;
  }

  onEventTypeChanged() {
    // The limits can come from the event type, so a type change alone can make
    // the current times valid or invalid.
    this.refreshTimeMessages();
    this.revalidateAfterChange();
  }

  onTimeChanges() {
    // Both helpers write to minMaxTimeError, so stop at the first failure rather than
    // letting the later check overwrite the message the user needs to see.
    if (this.verifyEventTimeValidity()) {
      this.verifyProgramMeetsMinMaxTimes();
    }

    this.revalidateAfterChange();
  }

  _addError(error) {
    this.errors.push(error);
  }

  _clearErrors() {
    this.errors.length = 0;
  }

  /* Getters/Setters */

  set minMaxTimeError(error) {
    this._minMaxTimeError = error;
  }

  get minMaxTimeError() {
    return this._minMaxTimeError;
  }

  get savingPosition() {
    return this._savingPosition;
  }

  set savingPosition(val) {
    this._savingPosition = val;
  }

  get location() {
    return this._location;
  }

  set eventDatePickerOpened(opened) {
    this._eventDatePickerOpened = opened;
  }

  get placesLoading() {
    return this._placesLoading;
  }

  set placesLoading(val) {
    this._placesLoading = val;
  }

  set locationSelectorVisible(val) {
    this._showLocationSelector = val;
  }
  get locationSelectorVisible() {
    return this._showLocationSelector;
  }

  get eventDatePickerOpened() {
    return this._eventDatePickerOpened;
  }

  set eventDatePickerOptions(val) {
    this._eventDatePickerOptions = val;
  }
  get eventDatePickerOptions() {
    return this._eventDatePickerOptions;
  }

  set GPSStatusMessage(message) {
    if (!message) {
      this._GPSStatusMessage = '';
    } else {
      this._GPSStatusMessage = this.translateFilter(message);
    }
  }

  get GPSStatusMessage() {
    return this._GPSStatusMessage;
  }

  get canEditPosition() {
    return this.position && this.position.canEdit;
  }

  set position(position) {
    this._position = position;
    this._unlockedCategories = position && position.unlocked_categories && position.unlocked_categories.split('|') || [];
  }

  get position() {
    return this._position;
  }

  get unlockedCategories() {
    return this._unlockedCategories || [];
  }

  /**
   * Set the selected venue to the position default
   */
  populateSelectedSearchVenueWithEventDefault() {
    this.selectedSearchVenue = {};
    this.selectedSearchVenue.vpid = this.position.event.vpid;
    this.selectedSearchVenue.venues_id = this.position.event.venues_id;
    this.selectedSearchVenue.clients_id = this.position.clients_id;
    this.selectedSearchVenue.client_name = this.position.client_name;
    this.selectedSearchVenue.venue_name = this.position.event.venue_name;
    this.selectedSearchVenue.street_address1 = this.position.event.street_address1;
    this.selectedSearchVenue.city = this.position.event.city;
    this.selectedSearchVenue.state = this.position.event.state;
    this.selectedSearchVenue.zip = this.position.event.zip;
    this.selectedSearchVenue.venues_types_id = this.position.event.venues_types_id;
    this.selectedSearchVenue.venues_types_name = this.position.event.venues_types_name;
    this.selectedSearchVenue.markets_id = this.position.event.markets_id;
    this.selectedSearchVenue.markets_name = this.position.event.markets_name;
    this.selectedSearchVenue.venues_types_name = this.position.event.venues_types_name;
    this.selectedSearchVenue.parent_chains_id = this.position.event.venues_parent_chains_id;
  }

  /**
   * Close the window
   */
  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  selectSearchVenue(value) {
    this.selectedSearchVenue = value;
  }

  dateDisabled() {
    if (this.program.blackout_type === BLACKOUT_DAYS_TYPES.PROGRAM) {
      const daysOfWeek = this.program.blackout_days.map(Number);
      return (data) => data.mode === 'day' && daysOfWeek.includes(data.date.getDay());
    }

    if (this.program.blackout_type === BLACKOUT_DAYS_TYPES.PROGRAM_CHAIN) {
      const chainsId = this.selectedSearchVenue?.parent_chains_id;
      if (chainsId) {
        const daysOfWeek = this.program.blackout_days[chainsId]?.map(Number);
        if (!daysOfWeek) return () => false;
        return (data) => data.mode === 'day' && daysOfWeek.includes(data.date.getDay());
      }
    }

    return () => false
  }

  openEventDatePicker() {
    const dateWindow = this._eventDateWindow({ includeScheduleRule: true });
    if (!dateWindow) {
      return; // No program or event type chosen, no date can be chosen
    }

    this._eventDatePickerOptions = {
      minDate: dateWindow.minDate,
      maxDate: dateWindow.maxDate,
      showWeeks: false,
      ...((this.program.blackout_type === BLACKOUT_DAYS_TYPES.PROGRAM || this.program.blackout_type === BLACKOUT_DAYS_TYPES.PROGRAM_CHAIN) && { dateDisabled: this.dateDisabled() }),
    };

    this.eventDatePickerOpened = true;
  }

  /**
   * Check if this is category is in the unlocked categories list
   * @param section
   * @returns boolean
   */
  canDisplayUnlockedCategory(section) {
    return this.unlockedCategories.indexOf(section) > -1;
  }

  /**
   * Checks that the save button can be displayed - requires that all required fields have
   * values and that venue has both an type and market
   * @returns boolean
   */
  canSave() {
    if (!this.canEditPosition) {
      return false;
    }


    return (
      (
        this.selectedSearchVenue.venues_types_id
        && this.selectedSearchVenue.markets_id
      )
      && this.editForm.name
      && this.editForm.date
    );
  }

  /**
   * Takes the address entered in the 'new address' tab and sets it as the selected venue
    */
  addAddress() {
    this.selectedSearchVenue = this.editForm.venue;

    const venueTypes = this.getVenueTypesForProgram();
    const venueType = venueTypes.find((val) => {
      return parseInt(val.id) === parseInt(this.editForm.venue.venues_types_id);
    });
    this.selectedSearchVenue.venues_types_name = venueType.name;

    const markets = this.getMarketsForProgram();
    const market = markets.find((val) => {
      return parseInt(val.id) === parseInt(this.editForm.venue.markets_id);
    });
    this.selectedSearchVenue.markets_name = market.name;
  }

  /**
   * Update the position - we're all done.
   */
  save() {
    this.savingPosition = true;
    if (!this.canSave()) {
      this.LogService.error("Attempted to save edit position form but canSave() is false");
      this.savingPosition = false;
      return false;
    }

    if (!this.collectValidationErrors()) {
      this.savingPosition = false;
      return false;
    }

    let task = this.TaskQueueService.createTask('PositionSaveTask');
    let data = { ...this.editForm };
    data.venue = this.selectedSearchVenue;
    data.event = this.position.event;

    /*
     * Note: Per MJOL-519 we're now trying to shift to proper timezone again
     * Per MJOL-1092 this breaks the date when local timezone would put us in a different day than  event
     */
    /*
    const eventTimezone = this.position && this.position.event && this.position.event.timezoneName;
    const origDate = data.date;

    if (eventTimezone && origDate) {
      const origDateNoSeconds = castToDateWithoutSeconds(origDate, eventTimezone);
      const unshiftedDate = this.DateTimeService.unshiftDateObjectFromLocal(origDateNoSeconds, eventTimezone);

      // TODO: Format in MM/DD/YYYY ?
      data.date = unshiftedDate;
    } else {
      // This is the original version:
      // We don't want time in UTC, it's local to the event
      data.date = this.moment(data.date).format('MM/DD/YYYY');
    }
     */

    const getCircularReplacer = () => {
      const seen = new WeakSet();
      return (key, value) => {
        if (typeof value === "object" && value !== null) {
          if (seen.has(value)) {
            return;
          }
          seen.add(value);
        }
        return value;
      };
    };

    data = JSON.parse(JSON.stringify(data, getCircularReplacer()));

    data.date = this.moment(data.date).format('MM/DD/YYYY');
    task.serializedPosition = this.PositionService.serialize(data);

    if (task.canExecute) {
      task.execute()
        .then(savedPosition => {
          this.LogService.log('Save position task completed with result:', savedPosition);
          return savedPosition;
        })
        .finally(() => {
          this.savingPosition = false;
          this.cancel();
          this.$scope.$emit('sync');
        });
    } else {
      const promise = this.TaskQueueService.enqueue(task)
        .then(result => {
          this.LogService.log('Enqueued position save task', task, 'result', result);
          return null;
        }).finally(() => {
          this.savingPosition = false;
        });
      this.cancel();
      return promise;
    }

    /*this.StaffUserService.editPosition(data)
      .then(function (response) {
        if (!response.success) {
          // Do something here to handle errors
        }
        // If we don't re-convert this back to a date object the date field goes blank after clicking.
        data.date = Date.parse(data.date);

        this.cancel();
        this.$scope.$emit('sync');

      });*/
  }
}

export default EditPositionModalController;

